import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Currency } from '../../models/currency';
import { CurrencyService } from '../../services/currency.service';
import { CommitteeService } from '../../services/committee.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.css']
})
export class CurrencyComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerCurrency: PageHeader;
  entity: Currency = new Currency();
  selectedCurrency: Currency = new Currency();
  editingEntity: Currency = new Currency();
  currency: any;
  CurrencyColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  locations: Array<Location> = [];
  selectedLocation: any; 
  employees: Array<Employee> = [];
  selectedEmployee: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  departments: Array<Department> = [];
  pipe = new DatePipe('en-US');
  opened: boolean = false;
  details: any;
  constructor(
    private _departmentService: DepartmentService,
    private _CurrencyService: CurrencyService,
    private _committeeService: CommitteeService,
    private _locationService: LocationService,
    private _employeeService: EmployeeService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerCurrency = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.currency = [];
    this.getAllCurrency();
  }
    ngAfterViewInit(): void {
    this.CurrencyColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },      
      { field: "CurrencyName", title: 'Currency', filter: true, sortable: true, width: 150 },
      { field: "CurrencyCode", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "Symbol", title: 'Symbol', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 50 }, 
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
   
  }

  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._CurrencyService.getAllCurrency('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Currency>) => {
      this.currency = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._CurrencyService.getAllCurrency(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((Currency: Array<Currency>) => {
        this.currency = {
          data: Currency,
          total: Currency[0] ? Currency[0].TotalCount : 0
        }
      });
    }
  }

  getAllCurrency() {
    this._CurrencyService.getAllCurrency('', Number(this.defaultPageSize), 1, 0, 0).subscribe((currency: Array<Currency>) => { 
      this.currency = {
        data: currency,
        total: currency[0] ? currency[0].TotalCount : 0
      } 
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._CurrencyService.deleteCurrency(this.selectedCurrency.Currency_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearCurrency();
            this.getAllCurrency();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerCurrency = new PageHeader();
    headerCurrency.PageCaption = "Currency";
    headerCurrency.IconClass = "bi bi-shield-shaded";
    return headerCurrency;
  }

  deleteCurrency(event: any) {
    if (event.seletedRows[0]) {
      this.selectedCurrency.Currency_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Currency",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addCurrency(event: any) {
    this.listView = false;
    this.clearCurrency(); 
    this.formCaption = "Add Currency";
  }

  editCurrency(event: any): void {
    if (event.seletedRows[0]) {
      this._CurrencyService.viewCurrency(event.seletedRows[0]).subscribe((Currency: Array<Currency>) => {
        let editEnity = Currency[0] ? Currency[0] : new this.currency(); 
        if (editEnity) { 
          this.editingEntity = editEnity;
          this.entity = { ...this.editingEntity }; 
          this.listView = false;
          this.formCaption = "Edit Currency"; 
          this.entity.EntityMetaData = [
            { FieldName: 'CurrencyName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Currency Name is required' },
            { FieldName: 'CurrencyCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            { FieldName: 'Symbol', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Symbol is required' },
          ];
        }
      });
    }
  }
  goToBackTab(): void {
    this.listView=true;
}
  save(event: any): void {
    if(parseInt(this.entity.CurrencyCode)==0){
      this.notification.showWarning("Zero not allowed")
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._CurrencyService.checkDuplication(this.entity.Currency_Id,this.entity.CurrencyCode).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Currency already exists');
          this.saveDisabled = false;
        }
        else {
          this._CurrencyService.saveCurrency(this.entity).subscribe(() => {
            if (this.entity.Currency_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearCurrency();
            this.getAllCurrency();
          })
        }
      });
    } 
    else {
      this.saveDisabled = false;
    }
  } 

  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    } 
  }

  gotoBack(): void {
    this.listView = true;
    this.getAllCurrency();
  }

  refreshCurrency(event: any): void {
    this.currency = [];
    this.getAllCurrency();
  }

  clearCurrency(): void { 
    this.entity = new Currency(); 
    this.saveDisabled = false; 
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.Currency_Id=dataItem.Currency_Id;
 this.details =[];
 this._CurrencyService.viewCurrency(this.entity.Currency_Id).subscribe((Currency: Array<Currency>) => {
  this.opened = true;
  this.details = Currency[0];
  })}

}
